import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=8225c6be&scoped=true&"
import script from "./filters.vue?vue&type=script&lang=js&"
export * from "./filters.vue?vue&type=script&lang=js&"
import style0 from "./filters.vue?vue&type=style&index=0&id=8225c6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8225c6be",
  null
  
)

export default component.exports
import {QScrollArea,QBtn,QInput,QToggle,QInnerLoading,QSpinnerHourglass} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QBtn,QInput,QToggle,QInnerLoading,QSpinnerHourglass})
